// extracted by mini-css-extract-plugin
var _1 = "AutoRenewal-module__link___YXNNL";
export { _1 as "link" }
